<template>
    <div>
        <Backer />
        <div class="fm-container">
            <div>
                <b-card-group deck>
                    <b-card
                        border-variant="primary"
                        header="Manage Products"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                    >
                        <!--b-card-text><button v-on:click="$router.push('/products/list/')">List Products</button></b-card-text-->

                        <b-card-text><b-button variant="dark" v-on:click="$router.push('/products/lookup/')">Lookup Product</b-button></b-card-text>

                        <b-card-text><b-button variant="dark" v-on:click="$router.push('/products/list/')">List Products</b-button></b-card-text>

                        <b-card-text><b-button variant="dark" v-on:click="$router.push('/products/addgroup/')">Add Product Groups</b-button></b-card-text>

                        <b-card-text><b-button variant="dark" v-on:click="$router.push('/products/catalog/')">Product Catalog</b-button></b-card-text>

                        <b-card-text><b-button variant="dark" v-on:click="$router.push('/products/vendors/')">Vendors List</b-button></b-card-text>

                    </b-card>
                </b-card-group>
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    export default {
        name: "ManageProducts",
        components: {Backer},
        data: function(){
            return {

            }
        },
        methods: {},
        created: function(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManageProducts.vue